import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import {
  POST_PROFILE_SURVEY,
  PROFILEENDPOINT,
} from "../../config/ApisCollection";
import axios from "axios";
import SpecificDietImage from "../../assets/imagehandler/SpecificDietImage";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SpecificDiet() {
  const dispatch = useDispatch();
  const accessToken = secureLocalStorage.getItem("accessToken");
  const [data, setData] = useState([]);
  const [activeMood, setActiveMood] = useState(null);
  const [selectedItemNum, setSelectedItemNum] = useState(0);

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(31));
  };

  const GetSpecificDiet = async () => {
    const get_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };

    await axios.get(PROFILEENDPOINT, get_header).then((response) => {
      setData(response.data.data);
    });
  };

  const handleChange = (index, itemId, isTrue, itemName) => {
    // Create a new copy of the surveyItems array
    const updatedSurveyItems = [...data.surveyItems];

    // Get current categoryItems
    const categoryItems = updatedSurveyItems[0].categoryItems;

    // Update the specific item within the categoryItems array
    const updatedCategoryItems = categoryItems.map(
      (item, i) =>
        // i === index ? { ...item, isTrue } : item // Multi select
        i === index ? { ...item, isTrue } : false // Single select
    );

    // Extract the names of the items

    const updatedDietaryItem = updatedCategoryItems
      .filter((item) => item.isTrue)
      .map((item) => item.name);

    // Apply the validation logic to determine which items should be selected

    let newDietaryItem = [...updatedDietaryItem];

    if (itemName === "All") {
      // Select all items and deselect "Nope"
      const allItems = categoryItems.map((item) => item.name);
      newDietaryItem = allItems;
      if (newDietaryItem.includes("Nope")) {
        newDietaryItem = newDietaryItem.filter((item) => item !== "Nope");
      }
    } else if (itemName === "Nope") {
      // Deselect all items and select "Nope"
      newDietaryItem = ["Nope"];
    } else {
      // Handle regular item selection
      if (newDietaryItem.includes(itemId)) {
        newDietaryItem = newDietaryItem.filter((item) => item !== itemId);
      } else {
        if (newDietaryItem.includes("Nope")) {
          newDietaryItem = newDietaryItem.filter((item) => item !== "Nope");
        }
        newDietaryItem.push(itemId);
      }

      // Deselect "All" if any item is selected/deselected
      if (newDietaryItem.includes("All")) {
        newDietaryItem = newDietaryItem.filter((item) => item !== "All");
      }

      // If all other items are selected, select "All"
      const allItems = categoryItems.map((item) => item.name);
      if (
        newDietaryItem.length === allItems.length - 2 &&
        !newDietaryItem.includes("Nope")
      ) {
        newDietaryItem.push("All");
      }
    }

    // Update the isTrue status based on newDietaryItem
    const updatedCategoryItemsWithStatus = categoryItems.map((item) => ({
      ...item,
      isTrue: newDietaryItem.includes(item.name) ? 1 : 0,
    }));

    // Update the surveyItems with the new categoryItems
    updatedSurveyItems[0].categoryItems = updatedCategoryItemsWithStatus;

    // Create a new data object with the updated surveyItems
    const updatedData = {
      ...data,
      surveyItems: updatedSurveyItems,
    };

    // Update the state with the new data object
    setData(updatedData);

    let counttrueval = 0;
    updatedSurveyItems[0].categoryItems.map((item, i) => {
      if (item?.isTrue == 1) {
        counttrueval++;
      }
    });
    setSelectedItemNum(counttrueval);
  };

  //------------------------post servey items------------------------------

  const postSurveyData = (surveyItemsData) => {
    //---------------deletion of uneccesary items--------------------------
    const category_are_you_following_specific_diet = Object.fromEntries(
      Object.entries(surveyItemsData[0].categoryItems).map(([key, value]) => {
        const { name, dark_icon, light_icon, imgname, subcat, ...rest } = value;

        return [key, rest];
      })
    );

    const postItems = {
      surveyItems: [
        {
          category: "are_you_following_specific_diet",
          categoryItems: Object.values(
            category_are_you_following_specific_diet
          ),
        },
      ],
    };

    //---------------deletion of unnecessary items---------------------------

    const live_url = POST_PROFILE_SURVEY;
    const postSurveyBody = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify(postItems),
    };

    fetch(live_url, postSurveyBody)
      .then((postSurRes) => postSurRes.json())
      .then((postSurResult) => {
        if (postSurResult["error"]) {
          if (postSurResult["error"].message === "token expired") {
            window.location.href = "/login";
          } else {
            toast.error(postSurResult.error.message);
          }
        } else {
          toast.success(postSurResult.message);
        }
      })
      .catch((postSurErr) => {});
  };

  useEffect(() => {
    GetSpecificDiet();
  }, []);

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack
          className="bg-transparent"
          handleCloseDrawer={handleCloseDrawer}
        />
        <ToastContainer position="bottom-right" />
      </div>

      {data?.surveyItems && data?.surveyItems[0] ? (
        <>
          <div className="text-center w-11/12 mt-2 mx-auto pb-8 gap-6 flex flex-col justify-between">
            <p className="text-2xl font-medium">
              Are you currently following a{" "}
              <span className="text-[#FF9950]"> specific dietary pattern </span>{" "}
              ?
            </p>
            <p className="text-sm">Choose all that apply</p>
          </div>
          <div className="max-w-[400px] m-auto grid grid-cols-2 mt-5 pt-5 justify-items-center mt-2 sm:mb-5 mb-5 sm:gap-5 gap-1 mob-grid-2">
            {data?.surveyItems &&
              data?.surveyItems[0]?.categoryItems?.map((diet_row, index) => {
                if (diet_row?.name !== "All") {
                  return (
                    <div
                      className={
                        diet_row.isTrue == 1
                          ? "gap-2 m-0 px-1.5 cardlyac  mb-2 font-bold w-[130px]"
                          : "gap-2 m-0 px-1.5 cardly  mb-2 w-[130px]"
                      }
                      key={index}
                      onClick={() => {
                        handleChange(
                          index,
                          diet_row.itemId,
                          diet_row.isTrue == 0 ? 1 : 0,
                          diet_row.name
                        );
                      }}
                    >
                      <div className="w-[88px] flex-col">
                        <img
                          loading="lazy"
                          src={SpecificDietImage["diet" + index]}
                          className="icongol m-auto"
                          alt="Very Often"
                        />
                        <div className="text-center mt-4 text-xs">
                          <p>{diet_row.name}</p>
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
          </div>
          {selectedItemNum != 0 ? (
            <button
              className="bg-[#FF9950] absolutes  bottom-10 text-white text-sm mx-auto w-full py-4 mt-6 rounded-2xl mb-10"
              onClick={() => {
                postSurveyData(data.surveyItems);
              }}
            >
              Update preferences
            </button>
          ) : (
            <button className="bg-[#ddd] absolutes bottom-10 text-white text-sm mx-auto w-full py-4 mt-6 rounded-2xl mb-10">
              Update preferences
            </button>
          )}
        </>
      ) : (
        <div className="flex flex-col justify-center h-[80vh]">
          <p className="text-center">Loading...</p>
        </div>
      )}
    </div>
  );
}
